export default __webpack_public_path__ + "static/media/Spinner-1s-200px.cb9b4f70.gif";